import { render } from "./VCardHeader.vue?vue&type=template&id=e4afec66"
import script from "./VCardHeader.vue?vue&type=script&lang=js"
export * from "./VCardHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__